import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import getCountryPrefix from 'Utils/getCountryPrefix';

import { AppProps } from './App';
import { CallCenter, RawPageData } from './types';

const getInitialState: GetInitialStateInner<AppProps, RawPageData> = (
  { item_data: itemdata, shopping_cart_items: shoppingCartItems },
  user,
) => {
  let callCenter: CallCenter | undefined;
  const {
    isCouponEnabled,
    show_contact_number: showContactNumber,
    useNewCreditCardFeature,
    membership_tag: membershipTag,
    item_promotion: itemPromotion,
    degreeSyllabusData,
    exitPopupCoupon,
    giftCard,
    incentiveData,
    isValidPartnershipItem,
    itemId,
    itemType,
    license_number: licenseNumber,
    popupPaymentFailedData,
    quantity,
    timer,
    pageCoupon,
  } = itemdata;

  const countryPrefix = getCountryPrefix();

  if (Object.keys(itemPromotion).length > 0) {
    callCenter = {
      adviserName: itemPromotion.adviser_name,
      adviserPhoto: itemPromotion.adviser_photo,
      customerName: itemPromotion.customer_name,
      expirationDate: itemPromotion.expiration_date,
      token: itemPromotion.token,
      hasExpired: itemPromotion.has_expired,
      isValidDuringCall: itemPromotion.is_valid_during_call,
      additionalMonths: itemPromotion.additional_time_number,
      additionalTimeText: itemPromotion.additional_time_text,
    };
  }

  return {
    productData: {
      isCouponEnabled: isCouponEnabled || undefined,
      showContactNumber: showContactNumber || undefined,
      membershipTag: membershipTag || undefined,
      callCenter: callCenter || undefined,
      degreeSyllabusData: degreeSyllabusData || undefined,
      exitPopupCoupon: exitPopupCoupon || undefined,
      giftCard: giftCard || undefined,
      incentiveData: incentiveData || undefined,
      itemId: parseInt(itemId, 10),
      itemType,
      licenseNumber: licenseNumber || undefined,
      popupPaymentFailedData: popupPaymentFailedData || undefined,
      quantity: quantity || undefined,
      timer: timer || undefined,
      pageCoupon,
      isValidPartnershipItem,
    },
    flags: {
      useNewCreditCardFeature,
    },
    shoppingCartItems: shoppingCartItems
      ? shoppingCartItems?.map(item => ({
          originalId: item.id,
          ...item,
        }))
      : undefined,
    countryPrefix,
    user,
    isDlocalABTest:
      countryPrefix === 'ar' ||
      countryPrefix === 'co' ||
      countryPrefix === 'cl',
  };
};

export default getInitialState;
